export function generateCorrelationId(): string {
	const uuid = crypto.randomUUID()
	const result = uuid.replace(/-/g, '')
	return result
}

export function header(key: string, value: string): Record<string, string> {
	const result = {[key]: value}
	return result
}
